import { render } from "./ArrowBottom.vue?vue&type=template&id=5f9c6f98"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__